/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import React from "react";
import ReactDOM from "react-dom";

// Let's create a Modal component that is an abstraction around
// the portal API.
export default class ModalPortal extends React.Component {
  constructor(props) {
    super(props);
    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    this.el = document.createElement("div");
    this.el.className = "modal-container";
  }
  /* istanbul ignore next */
  componentDidMount() {
    let modalRoot;
    if (this.props.reqId) {
      modalRoot = document.getElementById(this.props.reqId);
    } else {
      modalRoot = document.getElementById("modal-root");
    }

    // Append the element into the DOM on mount. We'll render
    // into the modal container element (see the HTML tab).
    modalRoot.appendChild(this.el);
    document.body.style.overflow = "hidden";
  }
  /* istanbul ignore next */
  componentWillUnmount() {
    const modalRoot = document.getElementById("modal-root");
    // Remove the element from the DOM when we unmount
    modalRoot.removeChild(this.el);
    document.body.style.overflow = "auto";
  }

  render() {
    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      // A DOM element
      this.el,
    );
  }
}
